import Button from 'components/UI/Button';
import { HookInput } from 'components/UI/HookForm/Form/Input';

const DefaultApplicantInformation = () => {
  return (
    <>
      <div className='py-6 px-4 space-y-6 h-full flex flex-col justify-between'>
        <h3 className='text-lg leading-6 font-medium text-green-500'>
          Applicant Information
        </h3>
        <section className='flex-1'>
          <div className='grid grid-cols-6 gap-6'>
            <HookInput
              customClassName='col-span-6 md:col-span-3'
              label='Full Name'
              name='applicantInformation.fullName'
              type='text'
            />
            <HookInput
              customClassName='col-span-6 md:col-span-3'
              label='Email'
              name='applicantInformation.contactEmail'
              type='email'
              placeholder='myemail@example.com'
            />
          </div>
        </section>
        <div className='flex flex-col gap-4 justify-end mt-5 md:flex-row'>
          <Button label='Next' btnStyle='primary' type='submit' />
        </div>
      </div>
    </>
  );
};

export default DefaultApplicantInformation;
